<template><div><h2>1px</h2>
<div class="tip">
<p>1px 方案在 VUX 组件内应用广泛，包括 Grid, ButtonTab, XTable, XButton, Cell 等等。<br>
<br><br>
<br><br>
利用 flexbox + 1px 你可以实现复杂的宫格布局。</p>
</div>
<p>在你项目的<code>App.vue</code>引入，组件内不需要再重复引入。</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">style</span> <span class="hljs-attr">lang</span>=<span class="hljs-string">"less"</span>&gt;</span><span class="undefined">
@import '~vux/src/styles/1px.less';
</span><span class="hljs-tag">&lt;/<span class="hljs-name">style</span>&gt;</span>
</code></pre>
<p>可用类名：</p>
<ul>
<li><code>vux-1px-l</code> 左边框</li>
<li><code>vux-1px-r</code> 右边框</li>
<li><code>vux-1px-t</code> 上边框</li>
<li><code>vux-1px-b</code> 下边框</li>
<li><code>vux-1px-tb</code> 上下边框</li>
<li><code>vux-1px</code> 全边框</li>
</ul>
<h2>close</h2>
<div class="tip">
<p>关闭图标主要应用于弹窗(popup)的左侧关闭按钮。</p>
</div>
<p>在你项目的<code>App.vue</code>引入，组件内不需要再重复引入。</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">style</span> <span class="hljs-attr">lang</span>=<span class="hljs-string">"less"</span>&gt;</span><span class="undefined">
@import '~vux/src/styles/close.less';
</span><span class="hljs-tag">&lt;/<span class="hljs-name">style</span>&gt;</span>
</code></pre>
<p>可用类名：</p>
<ul>
<li>vux-close</li>
</ul>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"vux-close"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
</code></pre>
<p>可以参考 <code>XDialog</code> 演示。</p>
<p>当你想设置图标颜色时，直接设置 color 即可。</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"vux-close"</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"color:red;"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
</code></pre>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// css-3.vue?cab28e0c